import * as React from "react";
import "../../style/fonts.css";
import "./message.css";
import icon from "../../icons/atoms/icon/magic@1x.png";
import bubble_start from "../../icons/Combined Shape.png";

export interface Props {
  text: string;
}

class Message extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <div className="MESSAGE_CONT">
        <div className="MESSAGE_ICON_CONT">
          <img src={icon} />
        </div>
        <div className="MESSAGE_BUBBLE_START">
          <img src={bubble_start} />
        </div>
        <div className="MESSAGE_BUBBLE_CONT">
          <div className="REG_TEXT">{this.props.text}</div>
        </div>
      </div>
    );
  }
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/message/message.tsx